module.exports = function(hljs) {
  return {
    aliases: ['console'],
    contains: [
      {
        className: 'meta',
        begin: '^\\s{0,3}[\\w\\d\\[\\]()@-]*[>%$#]',
        starts: {
          end: '$', subLanguage: 'bash'
        }
      },
    ]
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/highlight.js/lib/languages/shell.js
// module id = 1039
// module chunks = 0